import React from "react";
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaUser, FaEdit } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import "./Contact.css"; // External CSS for styling
import Footer from "./Footer";

const Contact = () => {
  const [result, setResult] = React.useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "0710c64b-9436-4dbb-9e52-6d4a5137a6af");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("");
      alert("Form Submitted Successfully")
      event.target.reset();
    } else {
      console.log("Error", data);
      alert(data.message)
      setResult("");
    }
  };
  return (
    <>
    <div className="contact-container">
      <div className="contact-info">
        <div className="info-card">
          <FaEnvelope className="icon" />
          <h3>Email Address</h3>
          <p>akari.sa@outlook.sa</p>
        </div>
        <div className="info-card">
          <FaPhone className="icon" />
          <h3>Phone Number</h3>
          <p>0504920299 <br/>0555966759</p>
        </div>
        <div className="info-card">
          <FaMapMarkerAlt className="icon" />
          <h3>Office Address</h3>
          <p>Saudi Arabia , Al-Ahsa , Thirty, Building-number-8012, zip-code-36365</p>
        </div>
      </div>
      
      <div className="quote-form">
        <h2>We'd love to hear from you</h2>
        <form onSubmit={onSubmit}>
          <div className="input-group">
            <input type="text" placeholder="Enter your name" required />
            <FaUser className="input-icon" />
          </div>
          <div className="input-group">
            <input type="email" placeholder="Enter email address" required />
            <MdEmail className="input-icon" />
          </div>
          <div className="input-group">
            <input type="tel" placeholder="Enter phone number" required />
            <FaPhone className="input-icon" />
          </div>
          <div className="input-group textarea">
            <textarea placeholder="Enter message" required></textarea>
            <FaEdit className="input-icon" />
          </div>
          <button type="submit" className="btn">{result ? result : "Send Message"}</button>
        </form>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default Contact;















/*import React from "react";
import { Link } from "react-router-dom";
import "./Contact.css"
import  Nav from "./Nav"    
import { RiFacebookBoxLine, RiYoutubeLine, RiGithubLine } from "react-icons/ri";
const Contact = () => {
  return (
    <>
    <Nav/>
      <section id="contact_Mini">
        <div className="super_container">
        <div className="container_1">
          <h3>Let's connect</h3>
          <div>
            <p>Phone</p>
            <span>+001 1234 999</span>
          </div>
          <div>
            <p>Email</p>
            <span>zk@gmail.com</span>
          </div>
          <div>
            <p>Address</p>
            <span>House No.123 Sector A-1</span>
          </div>
          <ul>
          <Link to={"/facebook"} target="_blank"><RiFacebookBoxLine/></Link>
          <Link to={"/facebook"} target="_blank"><RiFacebookBoxLine/></Link>
          <Link to={"/facebook"} target="_blank"><RiFacebookBoxLine/></Link>
        </ul>
        </div>
        
        <div className="container_2">
          <h3>We'd love to hear from you</h3>
          <form>
            <div>
              <input type="text" placeholder="Your Name"/>
              <input type="email" placeholder="Email"/>
            </div>
            <textarea rows="4" placeholder="Your Message..."/>
            <button type="submit">SEND</button>
          </form>
        </div>
        </div>
      </section>
    </>
  );
};

export default Contact;

*/
